import {Injectable} from '@angular/core';
import {ParameterBase} from '~/app/core/reports/models/ParameterBase';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {InputField} from '~/app/core/reports/models/input-field';
import {DateField} from '~/app/core/reports/models/date-field';
import {DateRangeField} from '~/app/core/reports/models/date-range-field';
import {Chain} from '~/app/core/reports/models/chain';
import {ChainSelectField} from '~/app/core/reports/models/chain-select-field';
import {ReportParams} from '@model/ReportParams';
import {Option} from '~/app/core/reports/models/option';
import {DropdownField} from '~/app/core/reports/models/dropdown-field';

@Injectable({
  providedIn: 'root'
})
export class ReportParamsService {


  yearParams =  [2017, 2018, 2019, 2020, 2021];
  weekParams = [1, 2, 3, 4, 5];
  periodParams = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  paramArray = [
    { name: 'p_BEG_BUS_DT',  type: Date, checkMatching: 'p_END_BUS_DT', title: 'Beginning Business Date', priority: 10},
    { name: 'p_END_BUS_DT',  type: Date,  checkMatching: 'p_BEG_BUS_DT', title: 'Ending Business Date', priority: 10},
    { name: 'p_BUS_DT',  type: Date, title: 'Business Date', priority: 10},
    { name: 'p_BUS_PRD',  type: Option, title: 'Business Period', priority: 10, data: this.periodParams},
    { name: 'p_BUS_WK',  type: Option, title: 'Business Week', priority: 10, data: this.weekParams},
    { name: 'p_BUS_YR',  type: Option, title: 'Business Year', priority: 10, data: this.yearParams},
    { name: 'p_CHN',  type: String, maxChar: 4, title: 'Chain', priority: 10},
    { name: 'p_CHN_STOR_LST',  type: Chain, maxChar: 3000, title: 'Chain Store List', priority: 1},
    { name: 'p_HO_ID',  type: Number, shown: false, priority: 10},
    { name: 'p_CHECK_NUM',  type: Number, title: 'Check Number' , priority: 10},
    { name: 'p_BATCH',  type: Number, title: 'Batch', priority: 10},
    { name: 'p_CATG_CD',  type: String, maxChar: 3000, title: 'Catalog Code', priority: 10},
    { name: 'p_PREP_EMAIL',  type: String, maxChar: 3000, title: 'Preparer Email', priority: 10, },
    { name: 'p_PREP_NM',  type: String, maxChar: 12, title: 'Preparer Name', priority: 10},
    { name: 'p_PREP_PHONE',  type: String, maxChar: 12, title: 'Preparer Phone', priority: 10},
    { name: 'p_PRD',  type: String, maxChar: 2, title: 'Period', priority: 10},
    { name: 'p_REV_DT',  type: Date, title: 'Review Date', priority: 10},
    { name: 'p_REVERS_DT',  type: Date, title: 'Reverse Date', priority: 10},
    { name: 'p_SEC_USER_ID',  type: String, maxChar: 8, shown: false, title: '', priority: 10},
    { name: 'p_YEAR',  type: String, maxChar: 4, title: 'Year', priority: 10},
    { name: 'p_INV_DT_LST',  type: String, maxChar: 3000, title: 'Invoice Date List', priority: 10},
    { name: 'p_ITM_LST',  type: String, maxChar: 300, title: 'Item List', priority: 10},
    { name: 'p_MNU_ITEM',  type: String, mxxChar: 7, title: 'Menu Item', priority: 10},
    { name: 'p_SSN',  type: String, maxChar: 9, title: 'Social Security Number', priority: 10},
    { name: 'p_USER_ID',  type: String, maxChar: 8, priority: 10},
    { name: 'p_CHN_STOR',  type: String, maxChar: 3000, priority: 10},
  ];

  constantParams: ReportParams[] = [
    {entity: 'action', type: 'CFM', value: ''},
    {entity: 'b_action', type: 'CIP', value: 'xts.run'},
    {entity: 'cv.header', type: 'CIP', value: 'false'},
    {entity: 'cv.toolbar', type: 'CIP', value: 'false'},
    {entity: 'form name', type: 'CFM', value: 'reportForm'},
    {entity: 'm', type: 'CIP', value: 'portal/report-viewer.xts'},
    {entity: 'method', type: 'CFM', value: 'post'},
    {entity: 'run.outputFormat', type: 'CFM', value: ''},
    {entity: 'run.prompt', type: '', value: 'false'},
    {entity: 'target', type: '', value: '_blank'},
    {entity: 'ui.action', type: 'CIP', value: 'run'},
    {entity: 'ui.object', type: 'CFM', value: ''},
    {entity: 'ui.tool', type: 'CIP', value: 'CognosViewer'},
    {entity: 'CAMNamespace', type: 'CIP', value: 'mclane-tsp'},
    {entity: 'tb', type: 'CIP', value: '0'},
    {entity: 'nh', type: 'CIP', value: '1'},




  ];
  constructor() {
  }

  toFormGroup(fields: ParameterBase<string>[]) {
    const group: any = {};
    fields.forEach(param => {
      group[param.key] = param.required ?
        new FormControl(param.value || '', Validators.required) :
        new FormControl(param.value || '');
    });
    return new FormGroup(group);
  }

  buildFormUI(array) {
    const fields: ParameterBase<string>[] = [];
    array = array.sort((n1, n2) => n1.priority - n2.priority);
    array.forEach((item, x) => {
      if (item.shown == null) {
      let field;
        const matchFound = array.find((it) => it.name === item.checkMatching);
   if (item.type === Number || item.type === String) {
     field = new InputField({
       key: item.name,
       label: item.title,
       required: true,
       order: x
     });
      } else if (item.type === Option) {
        field = new DropdownField({
          key: item.name,
          label: item.title,
          required: true,
          order: x,
          dropdownOptions: item.data
        });
        } else if (item.type === Chain) {
        field = new ChainSelectField({
          key: item.name,
          label: item.title,
          required: true,
          order: 0,
        });

      } else if (!(item.type === Date && matchFound == null)) {
     if (item.checkMatching != null) {

       matchFound.shown = false;
       if (matchFound) {
         field = new DateRangeField({
           key: `${item.name}.${item.checkMatching}`,
           rangeOptions: {
             endTitle: matchFound.title,
             endRange: new Date(),
             startRange: new Date(),
             startTitle: item.title
           },
           required: true,
           order: x,
           label: `Date Range`,
           showMasterLabel: true
         });

       }
     }
   } else {
     field = new DateField({
       key: item.name,
       label: item.title,
       required: true,
       order: x
     });
   }
        fields.push(field);
    }
    });
    return fields;
  }

  getTypes(params: string[]) {
    const itemArray = [];
    params.forEach((item: string) => {
      const removeWhiteSpace = item.trim();
      const found = this.paramArray.find((param) => removeWhiteSpace.toUpperCase() === param.name.toUpperCase());
      if (found) { itemArray.push(found); }
    });
    // Fix Location of list
    itemArray.forEach((item, x) => {
      if ( item === 'p_CHN_STOR_LST') {
        itemArray.splice(x, 1);
        itemArray.unshift(item);
        return;
      }
    });
    return itemArray;
  }
}
